/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pageurl } from 'utils/environment';



// <<<<<<<<<<<<<<<<<<<<<< ---------------------- CUSTOM CONSOLE LOGGER ---------------------- >>>>>>>>>>>>>>>>>>>>> //
const log = pageurl.includes('showLogs=true') ? console.log.bind(window.console) : function(){};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export { log };